import React, { useRef, useState, useEffect } from 'react'

import { Overlay, Tooltip } from 'react-bootstrap'
import styled from 'styled-components'
import { webBtnSize, mobileBtnSize, widgetPadding } from './constants'
import { MapWidgetEvent } from './event'

const UnselectAllAreas = ({
    options,
    showAllAreas,
    cleanSelectedAsset,
    dashTheme,
    isMobile
}: {
    options: Array<MapWidgetEvent>
    showAllAreas: (value: number) => void
    cleanSelectedAsset: (cleanSearch?: boolean) => void
    dashTheme: string
    isMobile: string
}): React.ReactElement => {
    const [showHint, setShowHint] = useState<boolean>(false)

    const overlayRef = useRef(null)
    const containsArea = options.filter(option => option.asset_type === 'area').length > 0

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleToggle() {
        setShowHint(true)
    }
    function handleUntoggle() {
        setShowHint(false)
    }

    const mobileClass = isMobile ? 'isMobile' : ''

    if (containsArea) {
        return (
            <UnselectAllAreasContainer
                id={'showAreasContainer'}
                dashTheme={dashTheme}
                className={`${mobileClass} hasValue`}
            >
                <span
                    id="showAreasCloseButton"
                    onMouseOver={handleToggle}
                    onMouseOut={handleUntoggle}
                    onClick={(e: React.MouseEvent): void => {
                        e.preventDefault()
                        showAllAreas(0)
                        cleanSelectedAsset(true)
                    }}
                >
                    <i className="fa fa-minus-square-o" />
                </span>
                <Overlay
                    ref={overlayRef}
                    show={showHint}
                    target={() => document.getElementById('showAreasCloseButton')}
                    placement="right"
                >
                    <Tooltip id="overload-right">Unselect all areas</Tooltip>
                </Overlay>
            </UnselectAllAreasContainer>
        )
    } else {
        return null
    }
}

const UnselectAllAreasContainer = styled.div`
    position: absolute;
    left: ${widgetPadding}px;
    top: 75px;
    z-index: 1001;
    width: ${webBtnSize}px;
    transition: all 0.3s;
    font-size: 13px;

    &.hasValue,
    &:hover,
    &:focus-within {
        width: 150px;
    }

    #showAreasCloseButton {
        background: rgb(255, 255, 255) none repeat scroll 0% 0%;
        border: none;
        border-radius: 3px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        opacity: 0;
        animation: closingXAppear 0.3s 0.3s linear forwards;
        cursor: pointer;
        padding: 0;
        padding-left: ${webBtnSize}px;
        height: ${webBtnSize}px;
        box-shadow: 0 0px 3px rgba(0, 0, 0, 0.65);

        i {
            position: absolute;
            left: 9px;
            top: 50%;
            transform: translateY(-50%);
            color: #37a3ef;
        }

        @keyframes closingXAppear {
            100% {
                opacity: 1;
            }
        }
    }

    &.isMobile {
        font-size: 16px;
        overflow: hidden;
        width: ${mobileBtnSize}px;

        &:hover {
            width: calc(100% - ${widgetPadding * 2}px);
            ul,
            .noResult {
                display: block;
            }
            #showAreasCloseButton {
                display: unset;
            }
        }

        i {
            transform: translate3d(0, -50%, 0);
            left: 13px;
        }

        #showAreasCloseButton {
            display: none;
            width: ${mobileBtnSize}px;
            height: ${mobileBtnSize}px;
            opacity: 1;
            transform: translate(-100%, -50%);
            i {
                right: 40%;
            }
        }
    }
`

export default UnselectAllAreas
